import api from '@/services/api'
const url = (action) => `/posts${action}`

export async function getPosts () {
  const { data } = await api.get(url(''))
  return data
}
